// extracted by mini-css-extract-plugin
export default {"container":"teams_container__Jsd3l","mainDiv":"teams_mainDiv__+BmaS","day":"teams_day__dB8oL","night":"teams_night__8otRI"};